import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class AbandonWorkflowRun {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
	) {
		Object.freeze(this);
	}
}

export default AbandonWorkflowRun;
